import { gql } from '@apollo/client'

export const AUTHENTICATE_CLIENT_FOR_TOKEN = gql`
  mutation generateAuthToken($input: TokenForAuthenticationInput!) {
    authenticateClientForToken(input: $input) {
      token
    }
  }
`
